// extracted by mini-css-extract-plugin
export default {"slider":"partners_slider__QnMq1","slide":"partners_slide__dFMFv","partnerItem":"partners_partnerItem__JgG6N"};